module.exports = __webpack_public_path__ + "img/writing-new.6ad0c8f9.svg";